import React from "react";
import { Map, type LatLng } from "@strava/feature-global-wasm-mre";

import getBlipClassName, { isRecording } from "./blipClassName";
import BeaconPulse from "./BeaconPulse";
import styles from "./BeaconMap.scss";

interface BeaconProps {
  latLng: LatLng;
  status: number;
}

const Beacon = ({ latLng, status }: BeaconProps) => (
  <Map.PlaceHTMLOnMap latLng={latLng} className={styles.htmlOverlay}>
    <div className={styles.beaconMarker}>
      {isRecording(status) && <BeaconPulse />}
      <div className={getBlipClassName(status)} />
    </div>
  </Map.PlaceHTMLOnMap>
);

export default Beacon;
